import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext } from 'react';
import { TabLayout } from 'console/shared/components/tab/layout';
import { DeviceUISettingsContent } from 'console/shared/contexts/device-ui-settings/types';
import { SortablePanels } from 'console/shared/components/features/sortable-panels';
export const HeatingTabContent = memo(function HeatingTabContent() {
    const { panels } = useContext(DeviceUISettingsContent);
    return (_jsx(TabLayout, { children: _jsx(SortablePanels, { list: panels }) }));
});
